import React, { useEffect, useState } from "react";
import "./loginPage.scss";
import logo from "../../Assets/svg/idfc logo.svg";
import engLogo from "../../Assets/svg/eng-logo2.svg";
import mbaLogo from "../../Assets/svg/mba logo.svg";
import { useSelector, useDispatch } from "react-redux";
import Impact from "../../Assets/svg/Impact.js";

import topImg from "../../Assets/svg/topVector.svg";
import btmImg from "../../Assets/svg/bottomVector.svg";
import { resetTimerData } from "../IdfcLetterHead/redux/actions";

function LoginPage(props) {
  const dispatch = useDispatch() 
  const [Link, setLink] = useState("");
  const registeredData = useSelector((state) => state.register.registeredData);

  const [mobile, setMobile] = useState("");
  const [valid, setValid] = useState(true);
  // console.log('in login page')
  useEffect(() => {
    dispatch(resetTimerData())

    let currentUrl = window.location.href;
    // const url = new URL(currentUrl);
    // const baseUrl = `${url.protocol}//${url.host}`;
    const cleanedUrl = currentUrl.replace(/^https?:\/\/(www\.)?/, "");
    // console.log("window", cleanedUrl.split("/")[0]);
    setLink(cleanedUrl);

    window.onload = function () {
      localStorage.clear();
    };
  }, []);
  // console.log("Link.split('/')[1]", Link.split('/')[1])
  return (
    <div className="login-page">
      {/* <Header/> */}
      <div className="left-content content">
        <div className="top-content">
          <div
            className={`logo showBg ${
              registeredData?.info?.course?.includes("ENGINEERING")|| registeredData?.info?.course?.includes("Engineering") 
                ? "showBg"
                : ""
            }`}
          >{registeredData?.info?.course?.includes("ENGINEERING")|| registeredData?.info?.course?.includes("Engineering")|| registeredData?.info?.course?.includes("MBA") ?
            <img
              src={
                registeredData?.info?.course?.includes("ENGINEERING")|| registeredData?.info?.course?.includes("Engineering") 
                   ? engLogo
                   :  mbaLogo
                   
              }
              alt="logo"
            />: <Impact/>}
          </div>
          <div className="greet">
            <div className="greet-title">
              Welcome to IDFC FIRST Bank’s{" "}
              {registeredData?.info?.course?.includes("ENGINEERING")|| registeredData?.info?.course?.includes("Engineering") 
                ? "Engineering"
                : registeredData?.info?.course.includes("MBA")
                ? "MBA"
                : ""}{" "}
              Scholarship Program
            </div>
            {/* <div className="greet-subtitle ">Application Platform </div> */}
          </div>

          <div
            style={
              registeredData?.info?.course?.includes("ENGINEERING")|| registeredData?.info?.course?.includes("Engineering") 
                ? { opacity: "0" }
                : {}
            }
            className="greet-btm-text"
          >
            <div className="left-text text">
              <div className="top-text">1154+</div>
              <div className="btm-text">scholarships awarded </div>
            </div>
            <div className="right-text text">
              <div className="top-text">152+</div>
              <div className="btm-text">Colleges across India</div>
            </div>
          </div>
        </div>
        <div className="btm-content">
          We use cookies.{" "}
          <a href="https://www.idfcfirstbank.com/privacy-policy">Click here</a>{" "}
          to see our policy.
        </div>
      </div>
      <div
        className={`right-content content ${
          Link.split("/")[1] === "signup" ? "signup" : ""
        } ${Link.split("/")[2] ?? ""}`}
      >
        {props.children}
        {/* <Routes>
          <Route path="/" element={<SignIn />} />
          <Route path="signup" element={<SignUp />} />
        </Routes> */}
        {/* <SignIn/> */}
        <div className="btm-content">
          Copyright© 2024 IDFC FIRST Bank Ltd. All Rights Reserved.
        </div>
      </div>
      {/* <div className="bg-img"> */}
      <div className="top-img">
        <img src={topImg} alt="top img" />
      </div>
      <div className="btm-img">
        <img src={btmImg} alt="top img" />
      </div>
    </div>
  );
}

export default LoginPage;
